export default "__VITE_ASSET__Bf7Tz2Cg__"